import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

const style = {
  container: {
    padding: 8,
    position: 'relative',
    marginBottom: 24,
    width: '100%',
    border: '1px solid #BDBDBD',
    borderRadius: 4,
  },
  title: {
    top: -8,
    left: 8,
    margin: 0,
    position: 'absolute',
    backgroundColor: 'white',
    padding: '2px 8px',
  },
};

const SectionDivider = props => {
  const { label, children, classes, className, ...rest } = props;
  return (
    <div className={classes.container} {...className} {...rest}>
      <h6 className={classes.title}>{label}</h6>
      {children}
    </div>
  );
};

SectionDivider.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.PropTypes.node.isRequired,
};

SectionDivider.defaultProps = {
  className: '',
};

export default withStyles(style)(SectionDivider);
